import { backendUrl } from 'helpers/environment';

export const apiFetch = async <T>(loc: string) => {
  const response = await fetch(`${backendUrl}${loc}`, { credentials: 'include' });
  if (!response.ok) {
    throw new Error('Network error', { cause: `status code: ${response.status}` });
  }
  return response.json() as T;
};

export const apiLogin = async (token: string, callback: string) => {
  const url = `${backendUrl}/auth/login?idToken=${token}&callback=${callback}`;
  return fetch(url);
};

export const apiLogout = async () => {
  const url = `${backendUrl}/auth/logout`;
  return fetch(url, { method: 'POST' });
};
